export var SourceAlignment;
(function (SourceAlignment) {
    SourceAlignment["HORIZONTAL_LEFT"] = "horizontal_left";
    SourceAlignment["HORIZONTAL_RIGHT"] = "horizontal_right";
    SourceAlignment["HORIZONTAL_CENTER"] = "horizontal_center";
    SourceAlignment["VERTICAL_TOP"] = "vertical_top";
    SourceAlignment["VERTICAL_BOTTOM"] = "vertical_bottom";
    SourceAlignment["VERTICAL_CENTER"] = "vertical_center";
})(SourceAlignment || (SourceAlignment = {}));
